import {ArrowRight, Instagram} from 'lucide-react'
import WaveLines from "@/components/WaveLines"

function LineIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor">
      <path d="M19.7 4.6C17.8 3.2 15.1 2.4 12.2 2.4 6.8 2.4 2.4 5.9 2.4 10.2c0 3.9 3.5 7.2 8.2 7.8.32.07.75.21.86.48.1.25.06.64.03.9l-.14 1.05c-.04.24-.2 1 .95.54 1.16-.46 6.24-3.68 8.52-6.3 1.56-1.7 2.3-3.43 2.3-5.27 0-2.3-1.2-4.4-3.42-5.8Z" />
    </svg>
  )
}

function Footer() {
  return (
    <footer id="contact" data-nav="light" className="relative overflow-hidden bg-[#7fa0b4] text-white">
      <WaveLines />
      <div className="grain absolute inset-0" />

      <div className="relative mx-auto flex min-h-[620px] max-w-5xl flex-col items-center justify-center px-8 py-24 text-center">
        <h2 className="font-serif-tc text-[36px] font-light leading-relaxed tracking-[0.1em] md:text-[48px]">
          唱過心裡的傷，
          <br />
          走向下一束光。
        </h2>
        <p className="mt-8 font-serif-tc text-xl tracking-[0.2em]">微光</p>
        <p className="mt-1 font-display text-lg italic tracking-[0.16em] text-white/80">Inner Light</p>
        <a
          href="#order"
          className="mt-10 inline-flex items-center gap-3 rounded-full border border-white/70 px-7 py-2.5 text-[12px] tracking-[0.22em] transition hover:bg-white hover:text-[#2d4658]"
        >
          立即收藏
          <ArrowRight size={14} />
        </a>
      </div>

      <div className="relative border-t border-white/15 px-8 py-8 md:px-10">
        <div className="mx-auto flex max-w-5xl flex-col gap-6">
          <div>
            <p className="font-display tracking-[0.28em]">MR.EAR</p>
            <nav className="mt-3 flex flex-wrap gap-5 text-[11px] tracking-[0.22em] text-white/70">
              <a href="#about">ABOUT</a>
              <a href="#story">STORY</a>
              <a href="#product">PRODUCT</a>
              <a href="#contact">CONTACT</a>
            </nav>
          </div>

          <div className="flex items-center gap-4 text-white/80">
            <a href="https://www.instagram.com/mr.ear_music/" aria-label="Instagram" target="_blank" rel="noreferrer">
              <Instagram size={16} />
            </a>
            <a href="https://lin.ee/qtAhTOw" aria-label="LINE" target="_blank" rel="noreferrer">
              <LineIcon />
            </a>
          </div>

          <div className="space-y-1.5 text-[11px] leading-6 tracking-[0.12em] text-white/70">
            <p>台北市南港區忠孝東路七段99號產業區三樓</p>
            <p>
              Email：
              <a href="mailto:info@mrearmusic.com" className="transition hover:text-white">
                info@mrearmusic.com
              </a>
            </p>
            <p>
              Phone：
              <a href="tel:0277094888" className="transition hover:text-white">
                02-77094888
              </a>
            </p>
          </div>

          <p className="text-right font-display text-[11px] leading-5 tracking-[0.2em] text-white/70">
            MUSIC
            <br />
            SCENT
            <br />
            A BETTER DAY
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-5xl text-[10px] tracking-[0.18em] text-white/40">
          © 2024 MR.EAR. ALL RIGHTS RESERVED.
        </p>
      </div>
    </footer>
  )
}

export default Footer
